import { config } from "../modules/config";

/**
 * Builds an asset URL.
 */
export function getAssetUrl(
  pathname: string,
  base = config.base ?? import.meta.url,
) {
  const root = base?.replace(/[^/]+\/?$/, "") ?? "";

  return joinUrlParts(root, pathname);
}

/**
 * Constructs a url given a list parts.
 */
export function joinUrlParts(...parts: string[]) {
  return parts.map((p) => p.replace(/^\/|\/$/g, "")).join("/");
}
